const ENV = process.env.REACT_APP_NODE_ENV;
const BASE_URL_SSD = ENV === 'production' ? process.env.REACT_APP_BASE_URL_SSD : (ENV === 'staging' || ENV === 'development' ) ? process.env.REACT_APP_BASE_URL_SSD_STAGING : 'http://localhost:8080/api';

export const getProjectsApi = async (user) => {

  try {
    if (user) {
      console.log('Fetching projects for user ' + user + '...');
      
      const options = {
        method: 'GET',
        headers: {
          'x-api-key': process.env.REACT_APP_API_KEY,
          'Content-Type': 'application/json',
          'email': user
        },
      };

      let result = await fetch(`${BASE_URL_SSD}/projects`, options); // fetch user's projects

      if (result.status === 200) {
        const res = await result.json();
        return res;
      };
    };
  } catch (error) {
    console.log('Error fetching projects!');
    console.log(error);
    return false;
  };
};

export const addProjectApi = async (project, lists, email) => {
  try {

    const options = {
      method: 'POST',
      headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({project, lists, email})
    };

    await fetch(`${BASE_URL_SSD}/projects`, options);
    return project;
  } catch (error) {
    console.log('Error adding project!');
    console.log(error);
    return project;
  };
};

// export const loadProjectApi = async (project) => {

//   try {
//     const options = {
//       method: 'GET',
//       headers: {
//         'x-api-key': process.env.REACT_APP_API_KEY,
//         'Content-Type': 'application/json',
//         'listIds': project.listIds
//       },
//     };

//     const lists = await fetch(`${BASE_URL_SSD}/lists`, options);
//     return lists;
//   } catch (error) {
//     console.log('Error adding project!');
//     console.log(error);
//     return null;
//   };
// };

// export const saveProjectApi = async (project, lists) => {

//   try {
//     const options = {
//       method: 'POST',
//       headers: {
//         'x-api-key': process.env.REACT_APP_API_KEY,
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({project: project, lists: lists})
//     };

//     await fetch(`${BASE_URL_SSD}/projects`, options);
//     return;
//   } catch (error) {
//     console.log('Error adding project!');
//     console.log(error);
//     return project;
//   };
// };

export const deleteProjectApi = async (projectId) => {

  try {
    console.log('Deleting project with id', projectId);
    const options = {
      method: 'DELETE',
      headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({projectId: projectId})
    };

    await fetch(`${BASE_URL_SSD}/projects`, options);
    return true;
  } catch (error) {
    console.log('Error deleting project!');
    console.log(error);
    return false;
  };
};
